// storage keys
export const LOCAL_STORAGE_TOKEN = "token";
export const LOCAL_STORAGE_USER = "user";

export const MIN_SIZE_SCREEN = 960;
